export const handleAttributeChange = (
  attributes: {
    customField: number;
    value: number | string;
  }[],
  id: number,
  value: any,
) => {
  attributes = attributes || [];
  const existingAttributeIndex = attributes
    ? attributes.findIndex((att) => att.customField === id)
    : -1;

  if (existingAttributeIndex !== -1 && attributes[existingAttributeIndex]) {
    attributes[existingAttributeIndex].value = value;
  } else {
    attributes.push({
      customField: id,
      value,
    });
  }

  return attributes;
};
